import { render, staticRenderFns } from "./ReceiptTransfers.vue?vue&type=template&id=0cb56bea&"
import script from "./ReceiptTransfers.vue?vue&type=script&lang=js&"
export * from "./ReceiptTransfers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports